import type { Species } from '../api/contract';
import { SPECIES } from '../lib/species';
import './legend.css';

const BANDS = [
  { min: 20, label: 'possible' },
  { min: 40, label: 'favorable' },
  { min: 60, label: 'très favorable' },
  { min: 80, label: 'excellent' },
] as const;

/** Maille coupée en deux, comme sur la carte : cèpe à gauche, girolle à droite. */
function SplitHex() {
  return (
    <svg viewBox="0 0 40 46" width="34" height="39" aria-hidden="true" className="legende-hex">
      <path d="M20 1 L20 45 L1 34 L1 12 Z" style={{ fill: 'var(--cepe-60)' }} />
      <path d="M20 1 L39 12 L39 34 L20 45 Z" style={{ fill: 'var(--girolle-60)' }} />
      <path d="M20 1 L39 12 L39 34 L20 45 L1 34 L1 12 Z" className="legende-hex-bord" />
    </svg>
  );
}

/** Légende des scores : la couleur n'est jamais seule, chaque teinte porte son libellé et sa plage. */
export function Legend({ shown }: { shown: Species[] }) {
  return (
    <div className="legende">
      {shown.length === 2 && (
        <p className="legende-moities">
          <SplitHex />
          <span>
            Chaque maille montre les deux espèces : <strong className="lieu">cèpe</strong> à gauche,{' '}
            <strong className="lieu">girolle</strong> à droite.
          </span>
        </p>
      )}
      <div className="legende-tableau" role="table" aria-label="Légende des scores">
        <div role="row" className="legende-ligne legende-entetes">
          <span role="columnheader" className="visually-hidden">
            Espèce
          </span>
          {BANDS.map((b, i) => (
            <span role="columnheader" key={b.min} className="legende-bande">
              <span className="legende-plage">
                {b.min}–{BANDS[i + 1] ? BANDS[i + 1]!.min - 1 : 100}
              </span>
              <span className="legende-texte">{b.label}</span>
            </span>
          ))}
        </div>
        {shown.map((s) => (
          <div role="row" className="legende-ligne" key={s}>
            <span role="rowheader" className="legende-espece lieu">
              {SPECIES[s].name}
            </span>
            {BANDS.map((b) => (
              <span role="cell" key={b.min} data-classe={b.min} className="legende-pastille" style={{ background: `var(--${s}-${b.min})` }}>
                <span className="visually-hidden">{b.label}</span>
              </span>
            ))}
          </div>
        ))}
      </div>
      <p className="legende-interdit">
        <span className="legende-hachure" aria-hidden="true" />
        Cœur du Parc national : cueillette interdite
      </p>
    </div>
  );
}
